import rItem from '@/components/ui/routeItem';

export const RouterItem = {
    install(Vue, options) {
        Vue.component(rItem.name, rItem)
    }
};




// WEBPACK FOOTER //
// ./src/components/ui/plugins.js